import { AsyncPipe, NgClass } from '@angular/common';
import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Optional,
  Output,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ErrorStateMatcher, MAT_RIPPLE_GLOBAL_OPTIONS, MatOption, RippleGlobalOptions } from '@angular/material/core';
import {
  MAT_FORM_FIELD_DEFAULT_OPTIONS,
  MatError,
  MatFormField,
  MatHint,
  MatLabel,
  MatPrefix,
  MatSuffix,
} from '@angular/material/form-field';
import { MatSelect } from '@angular/material/select';
import {
  DynamicFormControlComponent,
  DynamicFormControlCustomEvent,
  DynamicFormControlLayout,
  DynamicFormLayout,
  DynamicFormLayoutService,
  DynamicFormValidationService,
  DynamicSelectModel,
} from '@ng-dynamic-forms/core';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'dynamic-material-select',
  templateUrl: './dynamic-material-select.component.html',
  styleUrls: ['./dynamic-material-select.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [
    MatFormField,
    NgClass,
    ReactiveFormsModule,
    MatLabel,
    MatPrefix,
    MatSelect,
    MatOption,
    MatSuffix,
    MatHint,
    MatError,
    AsyncPipe,
  ],
})
export class DynamicMaterialSelectComponent extends DynamicFormControlComponent implements OnInit {
  @Input() formLayout: DynamicFormLayout;
  @Input() group: FormGroup;
  @Input() layout: DynamicFormControlLayout;
  @Input() model: DynamicSelectModel<string>;

  @Output() blur: EventEmitter<any> = new EventEmitter();
  @Output() change: EventEmitter<any> = new EventEmitter();
  @Output() customEvent: EventEmitter<DynamicFormControlCustomEvent> = new EventEmitter();
  @Output() focus: EventEmitter<any> = new EventEmitter();

  @ViewChild('matSelect', { static: true }) matSelect: MatSelect;

  constructor(
    protected layoutService: DynamicFormLayoutService,
    protected validationService: DynamicFormValidationService,
    @Inject(ErrorStateMatcher) public errorStateMatcher: ErrorStateMatcher,
    @Inject(MAT_FORM_FIELD_DEFAULT_OPTIONS) @Optional() public LABEL_OPTIONS: any,
    @Inject(MAT_RIPPLE_GLOBAL_OPTIONS) @Optional() public RIPPLE_OPTIONS: RippleGlobalOptions
  ) {
    super(layoutService, validationService);
  }

  ngOnInit() {
    if (this.model.getAdditional('type') === 'orderType') {
      this.group.patchValue({
        orderType: this.model.getAdditional('defaultValue'),
      });
      this.change.emit(this.group);
    }
  }
}
